
const deleteAssignment = (itemDetails, optimisticLiveSchedule, dayTypesAllowTour, resourceId) => {
  const { rdtId } = itemDetails;
  const jobElementId = itemDetails.id;
  const tempRdtId = `${rdtId}-optimistic`;
  // build new resource obj which will house dayTypes array, which houses tour obj, which houses assignments object
  const origResource = optimisticLiveSchedule.find((elem) => resourceId == elem.rId);
  const resource = JSON.parse(JSON.stringify(origResource));
  if (resource.dayTypes[rdtId]) {
    // create and populate new dayType
    resource.dayTypes[tempRdtId] = resource.dayTypes[rdtId];
    resource.dayTypes[tempRdtId].rdtId = tempRdtId;

    if (resource.dayTypes[rdtId].tour && resource.dayTypes[rdtId].tour.assignments) {
      // delete unwanted assignment
      delete resource.dayTypes[tempRdtId].tour.assignments[jobElementId];
    }
    // delete old dayType
    delete resource.dayTypes[rdtId];
  }
  return resource;
}

export default deleteAssignment;
